import React from "react";
import PrintIntro from "literacy/components/student/print/assign/trainintro";
import PrintTrain from "literacy/components/student/print/assign/trainpart";
import PrintProgress from "literacy/components/student/print/assign/train-progress";
import PrintHeader from "literacy/components/student/print/assets/header";
import { Container } from "@material-ui/core";

class PhonemePractise extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      start: false,
      id: "",
      version: "w1"
    };
  }

  render() {
    const { start, id, version } = this.state;
    return (
      <div style={{  backgroundImage: "linear-gradient(to right, #C7D28A, #7CA295)", fontFamily: "raven", height: window.innerHeight, overflowY: "scroll"}}>
        <Container>
          {start ? (
            id === "" ? (
              <PrintTrain version={version} />
            ) : (
                <PrintProgress id={id} />
              )
          ) : (
              <div>
                <PrintHeader part="Training Assignment" backURL="/literacy/student/print"/>
                <PrintIntro
                  handleClick={(id, version) => this.setState({ start: !start, id, version })}
                />
              </div>
            )}
        </Container>
      </div>
    );
  }
}
export default PhonemePractise;
